// extracted by css-extract-rspack-plugin
export default {"modal":"VWYntKwxs1LqBdVC","content":"DtmGLcYUHkkeclc9","section":"ufCn68I49bEPjGUA","icon":"jVymjMQdmID9ck7M","heading":"jiURzn35C3Y0xtVt","paragraph":"eBdYBmL52GoyEgMn"};